import { SelectableOption } from '../../../../../../common-controls/models/selectable-option';
import { ReferenceData } from '../../../../../../lib/models/reference-data.model';

export class FormSelectableOption extends SelectableOption {
  AreDetailsRequired: boolean;

  constructor(referenceData: ReferenceData) {
    super(referenceData);
  }
}
